import { fieldSubscriptionItems } from '../constants';
import filterSubscription from './filterSubscription';

const shallowEqualKeys = ['data'];

const filterFieldState = (state, prevState, subscription, force) => {
  const result = {
    blur: state.blur,
    change: state.change,
    focus: state.focus,
    name: state.name,
  };
  const diff =
    filterSubscription(
      result,
      state,
      prevState,
      subscription,
      fieldSubscriptionItems,
      shallowEqualKeys
    ) || !prevState;

  return diff || force ? result : undefined;
};

export default filterFieldState;
